const CANADIAN_DRIVER_LICENSE_RULES = {
  Alberta: {
    example: "123456789",
    maxLength: 9,
    message: "9 digits",
    regex: /^\d{9}$/,
  },
  "British Columbia": {
    example: "1234567",
    maxLength: 7,
    message: "7 digits",
    regex: /^\d{7}$/,
  },
  Manitoba: {
    example: "FELDVMA172Q2",
    maxLength: 12,
    message:
      "7 letters (or asterisk placeholders), 3 digits, then 2 letters or digits",
    regex: /^[A-Z*]{7}\d{3}[A-Z0-9]{2}$/,
  },
  "New Brunswick": {
    example: "1234567",
    maxLength: 7,
    message: "7 digits",
    regex: /^\d{7}$/,
  },
  "Newfoundland and Labrador": {
    example: "A123456789",
    maxLength: 10,
    message: "1 letter followed by 9 digits",
    regex: /^[A-Z]\d{9}$/,
  },
  "Nova Scotia": {
    example: "A1111123456789",
    maxLength: 14,
    message: "1 letter, 4 letters or asterisks, and 9 digits",
    regex: /^[A-Z][A-Z*]{4}\d{9}$/,
  },
  "Northwest Territories": {
    example: "123456789",
    maxLength: 9,
    message: "9 digits",
    regex: /^\d{9}$/,
  },
  Nunavut: {
    example: "12345",
    maxLength: 5,
    message: "5 digits",
    regex: /^\d{5}$/,
  },
  Ontario: {
    example: "A12345678901234",
    maxLength: 15,
    message: "1 letter followed by 14 digits",
    regex: /^[A-Z]\d{14}$/,
  },
  "Prince Edward Island": {
    example: "12345",
    maxLength: 5,
    message: "5 digits",
    regex: /^\d{5}$/,
  },
  Quebec: {
    example: "A123456789012",
    maxLength: 13,
    message: "1 letter followed by 12 digits",
    regex: /^[A-Z]\d{12}$/,
  },
  Saskatchewan: {
    example: "12345678",
    maxLength: 8,
    message: "8 digits",
    regex: /^\d{8}$/,
  },
  Yukon: {
    example: "123456",
    maxLength: 6,
    message: "6 digits",
    regex: /^\d{6}$/,
  },
};

export function normalizeCanadianDriverLicenseNumber(value) {
  return String(value || "")
    .trim()
    .replace(/[\s-]/g, "")
    .toUpperCase();
}

export function getCanadianDriverLicenseRule(province) {
  return CANADIAN_DRIVER_LICENSE_RULES[province] || null;
}

export function validateCanadianDriverLicense({
  country,
  province,
  licenseNumber,
}) {
  if (country !== "Canada") {
    return { valid: true };
  }

  const rule = getCanadianDriverLicenseRule(province);
  if (!rule) {
    return { valid: true };
  }

  const normalized = normalizeCanadianDriverLicenseNumber(licenseNumber);
  if (rule.regex.test(normalized)) {
    return { valid: true, normalized, rule };
  }

  return {
    valid: false,
    normalized,
    rule,
    message: `For ${province}, the licence number must be ${rule.message}. Example: ${rule.example}.`,
  };
}
